import { render, staticRenderFns } from "./StoperNumbers.vue?vue&type=template&id=5e29b2ae&scoped=true&"
import script from "./StoperNumbers.vue?vue&type=script&lang=js&"
export * from "./StoperNumbers.vue?vue&type=script&lang=js&"
import style0 from "./StoperNumbers.vue?vue&type=style&index=0&id=5e29b2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e29b2ae",
  null
  
)

export default component.exports